import request from 'superagent'
import types from '../types'

import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let apiUrl = `${protocol}//${hostname}:${api_port}/api`
if(api_port==='') {
  apiUrl = `${protocol}//${hostname}/api`
}

const getOvernightCareRequested = () => ({
  type: types.GET_OVERNIGHT_CARE_REQUESTED,
  payload: null
})

const getOvernightCareRejected = (error: any) => ({
  type: types.GET_OVERNIGHT_CARE_REJECTED,
  payload: error
})

const getOvernightCareFulfilled = (data: any) => ({
  type: types.GET_OVERNIGHT_CARE_FULFILLED,
  payload: data
})

export const getOvernightCare = (token: string) => {
  return (dispatch: any) => {
    dispatch(getOvernightCareRequested())
    request
      .get(`${apiUrl}/overnightCare`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .then((response) => {
        dispatch(getOvernightCareFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getOvernightCareRejected(error))
      })
  }
}